'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTextWeight = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n      font-weight: 400;\n    '], ['\n      font-weight: 400;\n    ']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      font-weight: 600;\n    '], ['\n      font-weight: 600;\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      font-weight: 700;\n    '], ['\n      font-weight: 700;\n    ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n    font-weight: ', ';\n  '], ['\n    font-weight: ', ';\n  ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n    ', '\n  '], ['\n    ', '\n  ']);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withTextWeight = exports.withTextWeight = function withTextWeight(_ref) {
  var weight = _ref.weight,
      fontWeight = _ref.fontWeight;

  if (weight) {
    var weights = {
      regular: (0, _styledComponents.css)(_templateObject),
      semiBold: (0, _styledComponents.css)(_templateObject2),
      bold: (0, _styledComponents.css)(_templateObject3)
    };

    return weights[weight];
  }

  return (0, _styledComponents.css)(_templateObject4, fontWeight);
};

exports.default = function () {
  return (0, _styledComponents.css)(_templateObject5, withTextWeight);
};